export const adminMenu = [
    { //hệ thống
        name: 'menu.system.header', menus: [
            {
                name: 'menu.system.system-administrator.header',
                subMenus: [
                    { name: 'menu.system.system-administrator.buyerAgent-manage', link: '/system/buyeragent-manage' },
                    { name: 'menu.system.system-administrator.banner-manage', link: '/system/banner-manage' },
                    { name: 'menu.system.system-administrator.category-manage', link: '/system/category-manage' },
                ]
            },
            { name: 'menu.system.system-client.header', link: '/system/client-manage' },

            { name: 'menu.system.system-staff.header', link: '/system/staff-manage' },
            { name: 'menu.system.system-country.header', link: '/system/country-manage' },
            { name: 'menu.system.system-warehouse.header', link: '/system/warehouse-manage' },

            { name: 'menu.system.system-product.header', link: '/system/product-manage' },
            { name: 'menu.system.system-order.header', link: '/system/order-manage' },
            { name: 'menu.system.system-shop.header', link: '/system/shop-manage' },

        ],
        // name: 'menu.system.header', menus: [
        //     {
        //         name: 'menu.system.system-administrator.header',

        //     },
        //     // { name: 'menu.system.system-parameter.header', link: '/system/system-parameter' },
        // ]
    },
];